import { httpRequest } from "@/lib";
import { useMutation, useQueryClient } from "@tanstack/react-query";

type Props = {
  budgetId: string;
};

const donwloadBudgetsToPDF = async ({ budgetId }: Props) => {
  const response = await httpRequest.get(`/budgets/${budgetId}/export-pdf`, {
    responseType: "blob",
  });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `budgets.pdf`);
  document.body.appendChild(link);
  link.click();
  if (link.parentNode) {
    link.parentNode.removeChild(link);
  } else {
    document.body.removeChild(link);
  }
};

export function useDownloadBudgetsToPDFMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: donwloadBudgetsToPDF,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["budgets-download-pdf"] });
    },
  });
}
